


















































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import FormInput from '@/components/lib/input/FormInput.vue'
import { StoreActionTypes } from '@/store/types'
import { SubscriptionModel, SubscriptionPlanModel, SubscriptionPlanType, SubscriptionUpdateModel } from '@/services/types'
import SubscriptionPlanSelect from '@/components/select/subscriptionPlan/SubscriptionPlanSelect.vue'
import * as utils from '@/services/utils'

@Component({
    components: {
        FormInput,
        SubscriptionPlanSelect
    }
})
export default class SubscriptionForm extends Vue {
    private componentClass = "SubscriptionForm"
    private planCode = null
    private price = 0
    private daysLeft = 0
    private usersTotalActive = 0
    private usersMax = 0
    private integrationsTotalActive = 0
    private integrationsMax = 0
    private startedAt = null
    private payedTo = null
    private payedAtDate = null
    private callsEstimationsTotalInPeriod = 0
    private callsEstimationsMax = 0

    mounted() {
        this.setSubscription()
    }

    async setSubscription() {
        await this.$store.dispatch(StoreActionTypes.SET_SUBSCRIPTION_PLANS_LIST)
		await this.$store.dispatch(StoreActionTypes.SET_SUBSCRIPTION_DATA)

        this.refresh()
    }

    get dataIsReady() {
        return !!this.$store.getters.getSubscriptionData && (this.$store.getters.getSubscriptionPlansList as SubscriptionPlanModel []).length > 0
    }

    onSubscriptionPlanSelect(planCode: SubscriptionPlanType) {
        this.planCode = planCode
        this.price = (this.$store.getters.getSubscriptionPlansList as SubscriptionPlanModel []).find(item => item.code == this.planCode).price
    }

    onChangePriceFormInput(text: string) {
        this.price = parseFloat(text)
    } 

    onChangeUsersMaxFormInput(text: string) {
        this.usersMax = parseInt(text)
    }

    onChangeIntegrationMaxFormInput(text: string) {
        this.integrationsMax = parseInt(text)
    }

    onChangeСallsEstimationsMaxFormInput(text: string) {
        this.callsEstimationsMax = parseInt(text)
    }

    setInitialDate(item: string) {
        const now = utils.getFormattedDate(new Date())
        return item && item.length > 0 ? item : now 
    }

    getSubscriptionUpdateModel(): SubscriptionUpdateModel {
        return {
            plan: {
                code: this.planCode,
                price: this.price
            },
            users: {
                max: this.usersMax
            },
            integrations: {
                max: this.integrationsMax
            },
            subscription: {
                startedAt: this.startedAt,
                payedTo: this.payedTo,
                payedAt: this.payedAtDate
            },
            callsEstimations: {
                max: this.callsEstimationsMax
            }
        }
    }

    refresh() {
        const subscription: SubscriptionModel = this.$store.getters.getSubscriptionData

        this.planCode = subscription.plan.code
        this.price = subscription.plan.price
        
        this.usersTotalActive = subscription.users.totalActive
        this.usersMax = subscription.users.max

        this.integrationsTotalActive = subscription.integrations.totalActive
        this.integrationsMax = subscription.integrations.max

        this.callsEstimationsTotalInPeriod = subscription.callsEstimations.totalInPeriod
        this.callsEstimationsMax = subscription.callsEstimations.max

        this.startedAt = this.setInitialDate(subscription.subscription.startedAt)
        this.payedTo = this.setInitialDate(subscription.subscription.payedTo)
        this.daysLeft = subscription.subscription.daysLeft
        this.payedAtDate = subscription.subscription.payedAt && subscription.subscription.payedAt.length > 0 ? utils.getDateFromDateTimeString(subscription.subscription.payedAt) : utils.getFormattedDate(new Date())
    }
}
